import { McIcon } from "./icon.js";



export class McIconLineChart extends McIcon {

  constructor() {
    super()
    const templ = document.createElement("template")
    templ.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-line h-6 w-6"
      aria-hidden="true">
      <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
      <path d="m19 9-5 5-4-4-3 3"></path>
    </svg>
`
    this.addHTML(templ)
  }
}


if (!window.customElements.get("mc-icon-linechart")) window.customElements.define("mc-icon-linechart", McIconLineChart)
